import React from "react";

class Discord extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <iframe
        src="https://e.widgetbot.io/channels/925867584283353149/926327608508026880"
        style={{
          flexGrow: "1",
          border: "none",
          margin: "0",
          padding: "0",
          marginTop: "-70px",
          borderRadius: "10px",
          height: "777px",
          minHeight: "100%",
          overflow: "hidden",
        }}
      ></iframe>
    );
  }
}

Discord.displayName = "Discord";

export default Discord;
